import * as React from 'react'
import { cn } from '../../../lib/utils'

/** Amber "Stray" chip — same treatment as the Model browser row badge. */
export function PlantStrayPill({
  isStray,
  className
}: {
  isStray: boolean
  className?: string
}): React.ReactElement | null {
  if (!isStray) return null
  return (
    <span
      title="Missing every placement anchor for this type"
      className={cn(
        'shrink-0 rounded-full border border-amber-400/40 bg-amber-500/10 px-1.5 py-0.5 text-10 font-medium text-amber-800 dark:text-amber-300',
        className
      )}
    >
      Stray
    </span>
  )
}
